import React from 'react';
import AppContextProvider from '../context/app';
import CartContextProvider from '../context/cart';
import CatalogContextProvider from '../context/catalog';
import CheckoutContextProvider from '../context/checkout';
import ErrorContextProvider from '../context/unhandledErrors';
import RootComponentsProvider from '../context/rootComponents';
import UserContextProvider from '../context/user';

/**
 * List of essential context providers that are required to run Peregrine
 *
 * @property {React.Component[]} contextProviders
 */
var contextProviders = [ErrorContextProvider, AppContextProvider, UserContextProvider, CatalogContextProvider, CartContextProvider, CheckoutContextProvider, RootComponentsProvider];
var PeregrineContextProvider = _ref => {
  var {
    children
  } = _ref;
  return contextProviders.reduceRight((memo, ContextProvider) => {
    return /*#__PURE__*/React.createElement(ContextProvider, null, memo);
  }, children);
};
export default PeregrineContextProvider;